import { FC } from 'react';
import { Anchor } from '@/components/ui/Anchor';
import { Navigator, Body, Item } from '@/components/ui/Navigator';
import styles from './Navi.scss';

const items = [
  { key: 'title', label: '報告書の名称' },
  { key: 'office', label: '集計に含める事業所' },
  { key: 'health_checkup_institution', label: '健康診断実施機関' },
  { key: 'specified_work_summaries', label: '労働安全衛生規則第13条第１項第３号に掲げる業務に従事する労働者数' },
  { key: 'health_checkup_summaries', label: '健康診断項目' },
  { key: 'physician', label: '産業医' },
  { key: 'submit_on', label: '提出年月日' }
];

export const Navi: FC = () => (
  <Navigator className={styles.navigator}>
    <Body className={styles.body}>
      {items.map(({ key, label }) => (
        <Item key={key} className={styles.item}>
          <Anchor name={key}>{label}</Anchor>
        </Item>
      ))}
    </Body>
  </Navigator>
);
